// @flow
export const controlLevelAvailableOptions = [6, 12, 16, 18, 21]
export const initialDefaultControlLevel = 16

export const initialPinCode = '0000'

export const defaultTimeToLock = 15000
